import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

// Define the type for a company
interface Review {
  user: string;
  rating: number;
  comment: string;
}

interface Company {
  name: string;
  location: string;
  certificates: string[];
  yearsInService: number;
  reviews: Review[];
}

// Define the mock data with the proper type
const mockCompanyDetails: { [key: number]: Company } = {
  1: {
    name: "Alpha Security",
    location: "New York, NY",
    certificates: ["ISO 9001", "SEC 2000"],
    yearsInService: 10,
    reviews: [
      { user: "John", rating: 5, comment: "Excellent service!" },
      { user: "Jane", rating: 4, comment: "Very professional, but a bit late." },
    ],
  },
  2: {
    name: "Bravo Protection",
    location: "Los Angeles, CA",
    certificates: ["SEC 2000", "PSA 2020"],
    yearsInService: 7,
    reviews: [
      { user: "Alice", rating: 5, comment: "Great experience!" },
      { user: "Bob", rating: 3, comment: "Okay service, could be better." },
    ],
  },
  // Add more mock data for other companies as needed
};

const CompanyDetail = () => {
  const { id } = useParams<{ id: string }>();
  const [company, setCompany] = useState<Company | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Mock API call to fetch company details based on id
    if (id) {
      const companyDetails = mockCompanyDetails[parseInt(id)];
      if (companyDetails) {
        setCompany(companyDetails);
        setError(null); // Reset error if company is found
      } else {
        setError("Company not found.");
      }
    }
  }, [id]);

  if (error) return <div>{error}</div>;

  if (!company) return <div>Loading...</div>;

  return (
    <div className="p-4">
      <div className="shadow-lg p-6 rounded-lg">
        <h1 className="text-3xl font-bold mb-2">{company.name}</h1>
        <p className="text-lg font-semibold mb-2">Location: {company.location}</p>
        <p className="text-lg font-semibold mb-2">
          Years in Service: {company.yearsInService}
        </p>
        <p className="text-lg font-semibold mb-2">Certifications & Licenses:</p>
        <ul className="list-disc pl-5">
          {company.certificates.map((cert, index) => (
            <li key={index}>{cert}</li>
          ))}
        </ul>

        <div className="mt-4">
          <h2 className="text-2xl font-semibold mb-2">Reviews:</h2>
          <div className="space-y-4">
            {company.reviews.map((review, index) => (
              <div key={index} className="border-b pb-4">
                <p className="font-semibold">{review.user} (Rating: {review.rating}⭐)</p>
                <p>{review.comment}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyDetail;